import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    signal,
    ViewEncapsulation,
    ChangeDetectorRef,
} from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { S25PanelComponent } from "./s25.panel.component";

@TypeManagerDecorator("s25-ng-panels")
@Component({
    selector: "s25-ng-panels",
    template: `
        @for (panelGroup of panelsGroup(); track $index) {
            <div class="panelSection">
                @for (panel of panelGroup; track panel) {
                    <!-- mobile app needs class names for panel headers to determine which panels need z-index values to handle overlay issues -->
                    <s25-ng-panel [panel]="panel" [class]="panel.header.toLowerCase().split(' ').join('-')">
                    </s25-ng-panel>
                }
            </div>
        }
    `,
    styles: `
        :host {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(min(25em, 100%), 1fr));
            gap: 2rem;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25PanelComponent],
})
export class S25PanelsComponent implements OnInit {
    @Input({ required: true }) panels: Panel[];

    panelsGroup = signal<Panel[][]>([]); // Grouped panels by section
    init = signal(false);

    constructor(private cd: ChangeDetectorRef) {
        // Constructor logic if needed
    }

    async ngOnInit() {
        this.groupPanelsBySection();
        this.sortPanelsBySectionOrder();

        this.init.set(true);
        this.cd.detectChanges();
    }

    groupPanelsBySection() {
        const groupedPanels: Panel[][] = [];
        this.panels.forEach((panel) => {
            const section = panel.section;
            if (!groupedPanels[section]) {
                groupedPanels[section] = [];
            }
            groupedPanels[section].push(panel);
        });
        this.panelsGroup.set(groupedPanels);
    }

    sortPanelsBySectionOrder() {
        this.panelsGroup().forEach((sectionPanels) => {
            sectionPanels.sort((a, b) => a.sectionOrder - b.sectionOrder);
        });
    }
}

export type Panel<T = any> = {
    header: string;
    id: string;
    section: number;
    sectionOrder: number;
    content: {
        component: T;
        inputs?: any;
        outputs?: any;
    };
};
